module.exports = __webpack_public_path__ + "fonts/Young.c0e605da.woff";